import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Palette } from 'lucide-react';
import { Button } from '../components/ui/button';
import HeroSlider from '../components/HeroSlider';
import QualitySection from '../components/QualitySection';
import FeatureCards from '../components/FeatureCards';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="home-page">
      {/* Hero Section */}
      <section className="py-8 px-4 sm:px-6 lg:px-8">
        <HeroSlider />
      </section>

      {/* Custom Design CTA Banner */}
      <section className="px-4 sm:px-6 lg:px-8 py-8" data-testid="custom-design-cta">
        <div className="max-w-[1400px] mx-auto">
          <div className="bg-gradient-to-r from-amber-700 via-red-700 to-amber-700 p-8 relative overflow-hidden">
            <div className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `
                  repeating-linear-gradient(45deg, transparent, transparent 20px, white 20px, white 22px),
                  repeating-linear-gradient(-45deg, transparent, transparent 20px, white 20px, white 22px)
                `
              }}
            ></div>
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Palette className="h-8 w-8 text-white" />
                </div>
                <div>
                  <span className="text-amber-200 text-sm font-semibold tracking-wider uppercase">NEW FEATURE</span>
                  <h3 className="text-2xl md:text-3xl font-black text-white">Design Your Own Kilim Case</h3>
                  <p className="text-amber-100">Preview your phone with different traditional patterns</p>
                </div>
              </div>
              <Link to="/custom-design">
                <Button 
                  size="lg"
                  className="bg-white text-amber-800 hover:bg-amber-50 px-8 py-6 text-lg font-bold rounded-none shadow-xl"
                  data-testid="try-custom-design-btn"
                >
                  Try Custom Design
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section className="px-4 sm:px-6 lg:px-8">
        <QualitySection />
      </section>

      {/* Feature Cards */}
      <section className="px-4 sm:px-6 lg:px-8 mb-12">
        <FeatureCards />
      </section>

      {/* Bohemian CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-stone-900 relative overflow-hidden" data-testid="cta-section">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `
              repeating-linear-gradient(45deg, transparent, transparent 40px, #fbbf24 40px, #fbbf24 42px),
              repeating-linear-gradient(-45deg, transparent, transparent 40px, #dc2626 40px, #dc2626 42px)
            `
          }}
        ></div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <Sparkles className="h-8 w-8 text-amber-400 mx-auto mb-4" />
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Experience the <span className="text-amber-400">Amlaria</span> Difference
          </h2>
          <p className="text-lg text-stone-400 mb-8 max-w-2xl mx-auto">
            Visit our lounge to discover the perfect blend of bohemian luxury and modern phone protection.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/shop/iphone-cases">
              <Button 
                size="lg"
                className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-6 text-lg font-semibold rounded-none"
                data-testid="shop-collection-btn"
              >
                Shop Collection
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Link to="/lounge">
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-stone-600 text-stone-300 hover:bg-stone-800 px-8 py-6 text-lg font-semibold rounded-none"
                data-testid="visit-lounge-btn"
              >
                Visit Lounge
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
